import React, { useState, useEffect } from 'react';
import { db, auth } from '../config/firebaseConfig';
import { collection, addDoc, getDocs, deleteDoc, updateDoc, doc } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';

const WorkHoursPanel = () => {
  const [user] = useAuthState(auth);
  const [workHours, setWorkHours] = useState([]);
  const [date, setDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [editId, setEditId] = useState(null);

  const fetchWorkHours = async () => {
    const snapshot = await getDocs(collection(db, 'workHours'));
    const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setWorkHours(data);
  };

  useEffect(() => {
    fetchWorkHours();
  }, []);

  const handleSave = async () => {
    if (!date || !startTime || !endTime) return alert("Lütfen tüm alanları doldurun.");

    const newEntry = {
      userId: user?.uid || 'public', // Eğer giriş yapılmamışsa varsayılan ID
      date,
      startTime,
      endTime,
    };

    if (editId) {
      const ref = doc(db, 'workHours', editId);
      await updateDoc(ref, newEntry);
      setEditId(null);
    } else {
      await addDoc(collection(db, 'workHours'), newEntry);
    }

    setDate('');
    setStartTime('');
    setEndTime('');
    fetchWorkHours();
  };

  const handleDelete = async (id) => {
    if (window.confirm('Bu kaydı silmek istediğinize emin misiniz?')) {
      await deleteDoc(doc(db, 'workHours', id));
      fetchWorkHours();
    }
  };

  const handleEdit = (item) => {
    setDate(item.date);
    setStartTime(item.startTime);
    setEndTime(item.endTime);
    setEditId(item.id);
  };

  return (
    <div className="container mt-5">
      <h3 className="mb-4">Çalışma Saatleri Yönetim Paneli</h3>

      <div className="card p-4 mb-4">
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Tarih</label>
            <input type="date" className="form-control" value={date} onChange={e => setDate(e.target.value)} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Başlangıç Saati</label>
            <input type="time" className="form-control" value={startTime} onChange={e => setStartTime(e.target.value)} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Bitiş Saati</label>
            <input type="time" className="form-control" value={endTime} onChange={e => setEndTime(e.target.value)} />
          </div>
        </div>
        <button className="btn btn-success" onClick={handleSave}>
          {editId ? 'Güncelle' : 'Kaydet'}
        </button>
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>Tarih</th>
              <th>Başlangıç</th>
              <th>Bitiş</th>
              <th>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {workHours.map((item) => (
              <tr key={item.id}>
                <td>{item.date}</td>
                <td>{item.startTime}</td>
                <td>{item.endTime}</td>
                <td>
                  <button className="btn btn-sm btn-primary me-2" onClick={() => handleEdit(item)}>Düzenle</button>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>Sil</button>
                </td>
              </tr>
            ))}
            {workHours.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center">Henüz kayıt yok.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WorkHoursPanel;
